export default "__VITE_ASSET__527c1b98__"